<!-- 著作权 -->
<template>
  <div class="cr_wrap">
    <div class="cr_body">
      <div class="cr_content">
        <img
          :src="IMG_LOGO_SUPPORT"
          class="cr_img"
        >
        <div class="cr_text_wrap">
          <div class="cr_text">技术支持</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PCopyright',
  data() {
    return {
      IMG_LOGO_SUPPORT: require('@/assets/img/logo/logo.png')
    };
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.cr_wrap {
  background: #f7f8fa;
  height: 40px;
  width: 100%;
  position: relative;
  .cr_body {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    .cr_content {
      display: flex;
      font-size: 0;
      .cr_img {
        height: 14px;
      }
      .cr_text_wrap {
        margin-top: 2px;
        margin-left: 5px;
        display: flex;
        align-items: center;
        .cr_text {
          color: #c5c8ce;
          font-size: 12px;
        }
      }
    }
  }
}
</style>